import { z } from "zod";
import { DateValidation } from "../shared/date-validation";

const PartySchema = z.object({ PartyName: z.string().nullish() });
const DetailSchema = z.object({
  Subject: z.string().nullish(),
  Description: z.string().nullish(),
  Text: z.string().nullish(),
  OwnerId: z.string().nullish(),
  Sender: PartySchema.nullish(),
  Owner: PartySchema.nullish(),
  Organizer: PartySchema.nullish(),
});
export const SupportCaseActivityItemSchema = z.object({
  Id: z.string().uuid(),
  Created: DateValidation.nullish(),
  ActivityTypeCode: z.number().int(),
  Parties: z.array(PartySchema).nullish(),
  Attachments: z
    .array(
      z.object({
        Id: z.string().uuid(),
        AnonymousLink: z.string().nullish(),
        FileName: z.string().nullish(),
        MimeType: z.string().nullish(),
        FileSize: z.number().nullish(),
      }),
    )
    .nullish(),
  Email: DetailSchema.nullish(),
  Comment: DetailSchema.nullish(),
  PhoneCall: DetailSchema.nullish(),
  Appointment: DetailSchema.nullish(),
});
export type SupportCaseActivityItemType = z.infer<
  typeof SupportCaseActivityItemSchema
>;
